import { GlobalResponseObject, UnitRequest } from '@gtpl/shared-models/common-models';
import axios from 'axios';
import connection from './connection';
import { AllGrnResponseModel, CreateInvoiceForVoucher, grnAbstract, GrnData, GrnIdReq, GrnRequest, GrnResponseModel, InvoiceNumReq, InvoiceStatusReq, InwardFilterReq, LotCodesResponseModel, PayablesDashboardReq, ReceivedBoxesRequest, ReWeighmentInfo, ReweighmentReq, ReWeighMentResponseModel, ReWeighMentViewResponseModel, RmAuditRequest, RmGrnResponseModel, RMInvoicePrintReq, RmInvoiceReq, RmInvoiceUpdateReq, rmReweighmentreq, RMVehicleInfoResponse, VoucherVendorReq } from '@gtpl/shared-models/raw-material-procurement';
import { CommonResponse, PlantIdRequest, VehicleResponseModel } from '@gtpl/shared-models/masters';
import { AllSaleOrdersDetailsResponseModel, SaleOrderDropDownResponseModel } from '@gtpl/shared-models/sale-management';
import { GrnAbstractResponse, GrnInvoiceNumberRequest, GrnItemIdRequest } from "@gtpl/shared-models/procurement-management";
import { AverageRateRmReport, LotNoReq, YieldPerReq } from '@gtpl/shared-models/production-management';
import {PaybleComponentReq} from '@gtpl/shared-models/analytics-data'
export class RMGrnService {
    URL = connection.DEPLOY_URL + '/rm-grn';
    //     userid = connection.userid;
    //   role=connection.role;
    //   unitId=connection.unit_id;

    async createGrn(values): Promise<RmGrnResponseModel> {
        return await axios.post(this.URL + '/createGrn', values)
            .then(res => {
                return res.data
            })
    }
    async getAllGrnData(req:UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllGrn',req
            // {headers: {"userid" : this.userid,"role":this.role,"unit_id":this.unitId}}
        )
            .then(res => {
                return res.data
            })
    }
    async getGrnDataForId(value): Promise<GrnResponseModel> {
        return await axios.post(this.URL + '/getGrnById', value)
            .then(res => {
                return res.data
            })
    }
    async updateGrn(values): Promise<RmGrnResponseModel> {
        return await axios.post(this.URL + '/updateGrn', values)
            .then(res => {
                return res.data
            })
    }

    async updateReceivedBoxes(receivedBoxes: ReceivedBoxesRequest): Promise<GrnResponseModel> {
        return await axios.post(this.URL + '/updateReceivedBoxes', receivedBoxes)
            .then(res => {
                return res.data
            })
    }

    async assignToRM(values): Promise<CommonResponse> {
        return await axios.post(this.URL + '/assignToRM', values)
            .then(res => {
                return res.data
            })
    }

    async getAllLotCodes(plantIdRequest: PlantIdRequest): Promise<LotCodesResponseModel> {
        return await axios.post(this.URL + '/getAllLotCodes', plantIdRequest)
            .then(res => {
                return res.data
            })
    }
    async getAllSaleOrders(plantIdRequest: PlantIdRequest): Promise<SaleOrderDropDownResponseModel> {
        return await axios.post(this.URL + '/getAllSaleOrders', plantIdRequest)
            .then(res => {
                return res.data
            })
    }

    async getRmVehicleGrnById(grnId): Promise<RMVehicleInfoResponse> {
        return await axios.post(this.URL + '/getRmVehicleGrnById', grnId)
            .then(res => {
                return res.data
            })
    }
    async getGrnInfoByItemId(grnId): Promise<RMVehicleInfoResponse> {
        return await axios.post(this.URL + '/getGrnInfoByItemId', grnId)
            .then(res => {
                return res.data
            })
    }
    async getRmGrnDataById(grnReq: GrnRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmGrnDataById', grnReq)
            .then(res => {
                return res.data
            })
    }
    async updatePlantOrSubPlant(values): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updatePlantOrSubPlant', values)
            .then(res => {
                return res.data
            })
    }

    async getTraceabilityCodeForLot(lotNumber): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTraceabilityCodeForLot', lotNumber)
            .then(res => {
                return res.data
            })
    }

    async updateGrnAuditQty(req:RmAuditRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateGrnAuditQty', req)
            .then(res => {
                return res.data
            })
    }
    async getGRNAbstract(req?:grnAbstract) : Promise<GrnAbstractResponse>{
        return await axios.post(this.URL + '/getGRNAbstract', req)
        .then(res=>{
        return res.data
        })
    }

    async getGrnNumberDropdownInfoForRMInvoice() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getGrnNumberDropdownInfoForRMInvoice')
        .then(res=>{
        return res.data
        })
    }

    async getIndentNumberDropdownInfoForRMInvoice() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getIndentNumberDropdownInfoForRMInvoice')
        .then(res=>{
        return res.data
        })
    }

    async getGrnItemInfoForInvoice(req:RmInvoiceReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getGrnItemInfoForInvoice',req)
        .then(res=>{
        return res.data
        })
    }

    async updateInvoiceInfo(req:RmInvoiceUpdateReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/updateInvoiceInfo',req)
        .then(res=>{
        return res.data
        })
    }

    async createReweighmentInfo(req:ReweighmentReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/createReweighmentInfo',req)
        .then(res=>{
        return res.data
        })
    }

    async updateReweighmentStatus(req:GrnIdReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/updateReweighmentStatus',req)
        .then(res=>{
        return res.data
        })
    }

    async getGrnNumbersDropdownForReweighment() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getGrnNumbersDropdownForReweighment')
        .then(res=>{
        return res.data
        })
    }

    async getGrnInfoForPriceAccpetance(req:InvoiceStatusReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getGrnInfoForPriceAccpetance',req)
        .then(res=>{
        return res.data
        })
    }

    async updateInvoiceStatus(req:GrnIdReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/updateInvoiceStatus',req)
        .then(res=>{
        return res.data
        })
    }

    async getGrnNumberDropdownForPriceApproval(req:InvoiceStatusReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getGrnNumberDropdownForPriceApproval',req)
        .then(res=>{
        return res.data
        })
    }

    async getIndentNumberDropdownForPriceApproval(req:InvoiceStatusReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getIndentNumberDropdownForPriceApproval',req)
        .then(res=>{
        return res.data
        })
    }

    async getRMInvoicePrint(req:RMInvoicePrintReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRMInvoicePrint',req)
        .then(res=>{
        return res.data
        })
    }

    async getReWeightMentInfo(req:ReWeighmentInfo) : Promise<ReWeighMentResponseModel>{
        return await axios.post(this.URL + '/getGrnWeighInfo',req)
        .then(res=>{
            return res.data
        })
    }

    async getGrnItemInfoForReweighment(req:RmInvoiceReq) : Promise<ReWeighMentViewResponseModel>{
        return await axios.post(this.URL + '/getGrnItemInfoForReweighment',req)
        .then(res=>{
        return res.data
        })
    }
    async getPlantLotNumbers() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getPlantLotNumbers')
        .then(res=>{
        return res.data
        })
    }

    async getRefNoInfoAgainstCompany(req:RmInvoiceReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRefNoInfoAgainstCompany',req)
        .then(res=>{
        return res.data
        })
    }

    async getReweighmentDetails(req:rmReweighmentreq):Promise<CommonResponse>{
        return await axios.post(this.URL + '/getReweighmentDetails',req)
        .then(res=>{
            return res.data
            })
    }

    async  getGrnDropDownDetails(): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getGrnDropDownDetails')
        .then(res=>{
            return res.data
            })
    }
    async  getFarmerDropDown(): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getFarmerDropDown')
        .then(res=>{
            return res.data
            })
    }



    async updateReweighmentRemovedCount(req:GrnItemIdRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/updateReweighmentRemovedCount',req)
        .then(res=>{
        return res.data
        })
    }

    async getBatchNumberDropdownForInvoice() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getBatchNumberDropdownForInvoice')
        .then(res=>{
        return res.data
        })
    }

    async updateYieldPer(req:YieldPerReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/updateYieldPer',req)
        .then(res=>{
        return res.data
        })
    }

    async getGrnItemsForRmBudgetReport(month?: number, year?: number) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getGrnItemsForRmBudgetReport', { month, year })
        .then(res=>{
        return res.data
        })
    }

    async getRmInvoiceReport(req?:any) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmInvoiceReport',req)
        .then(res=>{
        return res.data
        })
    }

    async getBatchNumbers() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getBatchNumbers')
        .then(res=>{
        return res.data
        })
    }

    async getFarmers() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getFarmers')
        .then(res=>{
        return res.data
        })
    }

    async getCategorys() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getCategorys')
        .then(res=>{
        return res.data
        })
    }

    async getHarvestType() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getHarvestType')
        .then(res=>{
        return res.data
        })
    }

    async getAverageRateReport(req?:AverageRateRmReport) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAverageRateReport',req)
        .then(res=>{
        return res.data
        })
    }

    async getRmInvoiceInfo(req:InvoiceStatusReq) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmInvoiceInfo',req)
        .then(res=>{
        return res.data
        })
    }

    async getRmInvoiceItemsInfo(req:GrnInvoiceNumberRequest) : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmInvoiceItemsInfo',req)
        .then(res=>{
        return res.data
        })
    }

    async getProcurementEmployeeNames() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getProcurementEmployeeNames')
        .then(res=>{
        return res.data
        })
    }
    async getAllGrnNUmbers() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllGrnNUmbers')
        .then(res=>{
        return res.data
        })
    }
    async getAllLotCodesForGrading() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getAllLotCodesForGrading')
        .then(res=>{
        return res.data
        })
    }

    async getRmGrnDataByLotCode(req: LotNoReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmGrnDataByLotCode', req)
            .then(res => {
                return res.data
            })
    }

    async getRmGrmFullDataForGrading(req:any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmGrmFullDataForGrading',req)
            .then(res => {
                return res.data
            })
    }

    async getRmGrnDataByIds(grnReq: GrnRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmGrnDataByIds', grnReq)
            .then(res => {
                return res.data
            })
    }

    async getRmGrnfullDataForHarvest(req:any): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmGrnfullDataForHarvest',req)
            .then(res => {
                return res.data
            })
    }

    async getAddonCountsInfo(req: RmInvoiceReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAddonCountsInfo', req)
            .then(res => {
                return res.data
            })
    }

    async getTotalRMPayablesDashboard(req?:PayablesDashboardReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getTotalRMPayablesDashboard',req)
            .then(res => {
                return res.data
            })
    }   
    
    async getInvoiceAmountAgainstVendor(req: PaybleComponentReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getInvoiceAmountAgainstVendor', req)
            .then(res => {
                return res.data
            })
    }   

        async getOverdueInvoiceAmountAgainstVendor(req: PaybleComponentReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getOverdueInvoiceAmountAgainstVendor', req)
            .then(res => {
                return res.data
            })
    }  

            async getInwardReport(req?: InwardFilterReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getInwardReport', req)
            .then(res => {
                return res.data
            })
    }  

        async getInwardNo() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getInwardNo')
        .then(res=>{
        return res.data
        })
    }

        async getInwardType() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getInwardType')
        .then(res=>{
        return res.data
        })
    }

        async getInwardFarmers() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getInwardFarmers')
        .then(res=>{
        return res.data
        })
    }

        async getInwardProducts() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getInwardProducts')
        .then(res=>{
        return res.data
        })
    }

        async getInwardVouchers() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getInwardVouchers')
        .then(res=>{
        return res.data
        })
    }

            async getVendorsForInvoice() : Promise<CommonResponse>{
        return await axios.post(this.URL + '/getVendorsForInvoice')
        .then(res=>{
        return res.data
        })
    }

                        async getVouchersAgainstFarmerForFinance(req?:VoucherVendorReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getVouchersAgainstFarmerForFinance',req)
            .then(res => {
                return res.data
            })
    }
    async getInvoiceDetails(req?:InvoiceNumReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getInvoiceDetails',req)
            .then(res => {
                return res.data
            })
    }
       async getAllInvoiceNumbers(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllInvoiceNumbers')
            .then(res => {
                return res.data
            })
    }

                            async createInvoiceAgainstVoucher(req?:CreateInvoiceForVoucher): Promise<CommonResponse> {
        return await axios.post(this.URL + '/createInvoiceAgainstVoucher',req)
            .then(res => {
                return res.data
            })
    }

}